import React from "react"
import { USER_ROLE } from "../../@constants/user"
import { PRICE_ANALYSIS_ROUTES } from "../../@constants/routes"
import AppLayout from "Layout"
import PriceAnalysisPage from "./index"

export const PriceAnalysisRoutes = {
    path: PRICE_ANALYSIS_ROUTES.PATH,
    title: PRICE_ANALYSIS_ROUTES.TITLE,
    subtitle: PRICE_ANALYSIS_ROUTES.SUBTITLE,
    icon: 'chart-line',
    iconWeight: 'light',
    access: USER_ROLE.USER,
    element: <AppLayout />,
    children: [{
        element: <PriceAnalysisPage />,
        index: true
    }]
}
